import React from 'react'

const KidPage = () => {
  return (
    <div>KidPage</div>
  )
}

export default KidPage